<template lang="pug">
  transition(name="fade")
    .legend.legend--treads(:class="showMapLegend ? 'opened' : 'closed'")
      e-perfect-scrollbar
        .legend__head(@click="showMapLegend = !showMapLegend")
          h2.legend__title {{$translate('Обозначения')}}
          button.reset-btn.legend__close(v-if="showMapLegend")
          button.reset-btn.legend__open(v-else)
        .legend__group
          .legend__type
            label.legend__switch.switch
              span.semibold.legend__name Отобразить все элементы карты
              input.visually-hidden.switch__input(type="checkbox" @change="$emit('showAll', showAll)" v-model="showAll")
              span.switch__block
        .legend__group
          div.type.all-treads
            div.legend__type
              label.legend__switch.switch
                span.semibold.legend__name Отобразить все потоки
                input.visually-hidden.switch__input(type="checkbox" @change="$emit('showAllThreads', showAllThreads)" v-model="showAllThreads")
                span.switch__block
        .legend__group
          div.type.all-treads
            div.legend__type
              label.legend__switch.switch
                span.semibold.legend__name Тарифы
                input.visually-hidden.switch__input(type="checkbox" @change="$emit('showModelTariffs', showModelTariffs)" v-model="showModelTariffs")
                span.switch__block
        .legend__group
          .legend__type
            .semibold.legend__name {{$translate('Объекты обращения с отходами')}}
          .legend__small-group
            .legend__name
              .legend-icon.legend-icon_utilization
              span {{$translate('Объекты обращения с отходами')}}
          .legend__small-group
            .legend__name
              .legend-icon.legend-icon_mps
              span {{$translate('МПС (МПП)')}}
          .legend__small-group
            .legend__name
              .legend-icon.legend-icon_mmtzoo
              span {{$translate('ММЦОО')}}
        .legend__group
          .legend__type
            .semibold.legend__name {{$translate('Населенные пункты')}}
          .legend__small-group
            .legend__name
              .legend-icon.legend-icon_distribution
              span {{$translate('Отходы распределены')}}
          .legend__small-group
            .legend__name
              .legend-icon.legend-icon_no-distribution
              span {{$translate('Отходы не распределены')}}
        .legend__group
          .legend__type
            .custom-checkbox
              input.visually-hidden.custom-checkbox__input(type="checkbox" id="checkbox-thread" @change="showAllChange" v-model="showAllLine")
              label.legend__label.custom-checkbox__label(for="checkbox-thread")
                span.custom-checkbox__block
                span.custom-checkbox__text.semibold {{$translate('Потоки')}}
          .legend__small-group
            .custom-checkbox
              input.visually-hidden.custom-checkbox__input(type="checkbox" id="chekbox-thread-tko" @change="$emit('showTKOLine', showTKOLine)" v-model="showTKOLine")
              label.legend__label.custom-checkbox__label(for="chekbox-thread-tko")
                span.custom-checkbox__block
                span(:style="getLineStyle('fact', 'tko')").legend__line
                span {{$translate('ТКО')}}
          .legend__small-group
            .custom-checkbox
              input.visually-hidden.custom-checkbox__input(type="checkbox" id="chekbox-thread-other" @change="$emit('showOtherLine', showOtherLine)" v-model="showOtherLine")
              label.legend__label.custom-checkbox__label(for="chekbox-thread-other")
                span.custom-checkbox__block
                span(:style="getLineStyle('fact', 'other')").legend__line
                span {{$translate('Прочие отходы')}}
          .legend__small-group
            .custom-checkbox
              input.visually-hidden.custom-checkbox__input(type="checkbox" id="chekbox-thread-mixed" @change="$emit('showMixedLine', showMixedLine)" v-model="showMixedLine")
              label.legend__label.custom-checkbox__label(for="chekbox-thread-mixed")
                span.custom-checkbox__block
                span(:style="getLineStyle('fact', 'mixed')").legend__line
                span {{$translate('Смешанный поток')}}
        .legend__group
          .legend__type
            .legend__name.semibold {{$translate('Нагрузка объекта')}}
          .legend__small-group
            .legend__name
              .legend__line.legend__line_low
              span {{$translate('Минимальная нагрузка')}}
          .legend__small-group
            .legend__name
              .legend__line.legend__line_middle
              span {{$translate('Средняя нагрузка')}}
          .legend__small-group
            .legend__name
              .legend__line.legend__line_high
              span {{$translate('Максимальная нагрузка')}}
        map-statuses(
          @updateStatus="updateStatus"
        )
</template>

<script>
import { TREADS_POLY_STYLE, TREADS_POLY_SUBCOLOR } from '@/config/map'
import MapStatuses from './map-statuses'

export default {
  name: 'map-legend',
  components: { MapStatuses },
  props: {
    showRemoved: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      showAll: false,
      showAllThreads: false,
      showAllLine: true,
      showAllStatus: true,
      showStatusActive: true,
      showStatusPlan: true,
      showTKOLine: true,
      showOtherLine: true,
      showMixedLine: true,
      showModelTariffs: false,
    }
  },
  computed: {
    showMapLegend: {
      get() {
        return this.$store.state.showMapLegend
      },
      set(value) {
        this.$store.commit('mapLegend', value)
      },
    },
  },
  methods: {
    updateStatus({ type, val }) {
      this.$emit('updateStatus', { type, val })
    },
    showAllChange() {
      this.showTKOLine = this.showAllLine
      this.showOtherLine = this.showAllLine
      this.showMixedLine = this.showAllLine
      this.$emit('showTKOLine', this.showAllLine)
      this.$emit('showOtherLine', this.showAllLine)
      this.$emit('showMixedLine', this.showAllLine)
    },
    getLineStyle(type, subtype) {
      const style = { ...TREADS_POLY_STYLE[type] }

      if (subtype && TREADS_POLY_SUBCOLOR[subtype]) {
        style.color = TREADS_POLY_SUBCOLOR[subtype]
      }

      if (style.dashArray) {
        return `background:repeating-linear-gradient(90deg, ${style.color}, ${style.color} 10px, transparent 10px, transparent 20px);`
      }

      return `background:${style.color};`
    },
  },
}
</script>

<style>
.legend.legend--treads .type-group .type.all {
  border-bottom: none;
  margin-left: -4px;
}
.legend.legend--treads .type-group .type.all-treads {
  border-top: none;
  margin-left: -4px;
}
</style>
